export const headers = [
    {   
        text: 'Nome',
        sortable: true,
        value: 'name',
        width: '25%'
    },
    {
        text: 'CPF/CNPJ',
        sortable: true,
        value: 'cpfCnpj',
        width: '20%'
    },
    {
        text: 'Telefone',
        sortable: true,
        value: 'phone',
        width: '15%',
    },
    {
        text: 'Cidade',
        sortable: true,
        value: 'cityName',
        width: '20%',
    },
    {
        text: 'Ativo',
        sortable: true,
        value: 'active',
        width: '10%', 
    },
    {
        text: 'Ações',
        align: 'right',
        sortable: false,
        value: 'actions',
        width: '10%',
    }
]